import { CheckCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import ProgressBar from './ProgressBar';

interface WatchStatusProps {
    completed: boolean;
    percent: number;
    /** Width class for the bar under "In progress"; omit for label-only. */
    barClassName?: string;
    /** 'xs' for lists and cards, '2xs' for rail rows. */
    size?: 'xs' | '2xs';
    /** Which edge the label and bar hug when stacked. */
    align?: 'start' | 'end';
    className?: string;
}

/** The one watch-status vocabulary: Completed (check), In progress (+bar), Not started. */
export const WatchStatus: React.FC<WatchStatusProps> = ({
    completed,
    percent,
    barClassName,
    size = 'xs',
    align = 'end',
    className = ''
}) => {
    const textClass = `${size === 'xs' ? 'text-xs' : 'text-[11px]'} leading-none font-semibold`;

    if (completed) {
        return (
            <span
                className={`inline-flex items-center gap-1 ${textClass} text-green-500 ${className}`}
            >
                <CheckCircleIcon className={size === 'xs' ? 'w-3.5 h-3.5' : 'w-3 h-3'} />
                Completed
            </span>
        );
    }

    if (percent > 0) {
        return (
            <span
                className={`flex flex-col gap-1 ${align === 'end' ? 'items-end' : 'items-start'} ${className}`}
            >
                <span className={`${textClass} text-gray-800`}>In progress</span>
                {barClassName && (
                    <ProgressBar percent={percent} size="sm" className={barClassName} />
                )}
            </span>
        );
    }

    return <span className={`${textClass} text-gray-400 ${className}`}>Not started</span>;
};

export default WatchStatus;
